// extracted by mini-css-extract-plugin
export default {"button":"_3QhmW","info":"_3xXtR","arrow":"_2NGPa"};